import { Column, Entity, PrimaryColumn } from "typeorm"

@Entity({name: "voice_sims_details"})
export class VoiceSimsDetails {

	@PrimaryColumn()
	iccid!: string;

	@Column({ nullable: true })
	msisdn!: string;

	@Column({ nullable: true })
	network!: string;

	@Column({ nullable: true })
	client_name!: string;

	@Column({ nullable: true })
	tariff!: string;

	@Column({ type: "datetime", nullable: true, default: null })
	date_activated!: Date | null

	@Column({nullable: false, default: ""})
	custom_label!: string

	@Column({ nullable: true })
	device_type!: string
}